import { TriangleAlert } from 'lucide-react';

import type { FirstSendCopy } from '../../gallery/firstSendMock';
import { useFirstSendWarningCopy } from '../../hooks/useGalleryFirstSend';

/** Smart tokens instead of the lola white view; same copy and layout. */
export const SmartFirstSendWarning = ({
  copy = 'default',
}: {
  copy?: FirstSendCopy;
}) => {
  const { title, body } = useFirstSendWarningCopy(copy);

  return (
    <section className="first-send-warning first-send-warning--smart" role="note">
      <TriangleAlert size={20} aria-hidden />
      <div>
        <p className="first-send-warning-title">{title}</p>
        <p className="first-send-warning-body">{body}</p>
      </div>
    </section>
  );
};
